/**
 * Inline SVG fractal noise used as a lightweight paper-fibre texture for
 * decorative document sheets. Avoids a WebGL context per card.
 * Cloned from sentinel-web form-ui (no package import).
 */
export const PAPER_NOISE = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='120' height='120' filter='url(%23n)' opacity='0.4'/%3E%3C/svg%3E")`
